import React, { createContext, Component } from "react";
import { node, obj } from "prop-types";

const { Consumer, Provider } = createContext();

class NavbarProvider extends Component {
    static propTypes = {
        children: node,
        value: obj,
    };

    static defaultProps = {
        children: null,
        value: null,
    };

    render() {
        const { children, value } = this.props;
        return <Provider value={value}>{children}</Provider>;
    }
}

export { Consumer as NavbarConsumer, NavbarProvider };
